import { ParserPhase } from "../../text/lexer/parsing/ParserPhase";
import { RJToken } from "../expressions/RJToken";
import { RJParser } from "../RJParser";

export class RJCreateTokens extends ParserPhase<RJParser>
{
  static readonly phaseInfo = "RJ Create Expressions";
  get phaseInfo(){ return RJCreateTokens.phaseInfo; }
  
  _tokens:RJToken[];
  get tokens(){ return this._tokens; }


  process()
  {
    let events = this.parser.lexing.events;
    this._tokens = events.filter( e => ! e.isDone ).map( e => new RJToken( this.parser, e ) );
  }
}